Directives.SearchContactDirective =  function SearchContactDirective(){

    // @ngInject
    function SearchContactDirectiveControllerFunc($scope,  $injector, AppStates, $state, AnalyticsService, $filter){

        this.constructor.$super.call(this, $scope, $injector);
        this.$state = $state;
        this.AppStates = AppStates;
        this.AnalyticsService = AnalyticsService;
        this.__objectType = 'SearchContactDirectiveController';
        if(!this.avatarSize){
            this.avatarSize = 's';
        }

        this.contactNameHighlighted = $filter('highlight')(this.contactName, this.searchPhrase);

        this.contactEmailOrCompanyNameHighlighted =
            angular.isUndefined(this.replaceEmailWithCompanyName) || !this.replaceEmailWithCompanyName ?
                $filter('highlight')(this.contactEmail, this.searchPhrase) :
                $filter('highlight')(this.companyName, this.searchPhrase);
    }

    var SearchContactDirectiveController = Class(Controllers.BaseController, {
        constructor: SearchContactDirectiveControllerFunc,

        goContact: function goContact (){
            if (this.disableGotoContact === 'true'){
                return false;
            }

            this.$state.go(this.AppStates.root_core_navigation_contacts, {search: this.contactEmail}, {location: "replace"});

            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.search_result_item_clicked,
                {searched_id: this.contactName, searched_type: 'Contact'});
        }

    });

    return {
        scope:{
            contactName: '@contactName',
            contactEmail: '@contactEmail',
            companyRole: '@companyRole',
            companyName: '@companyName',
            jobTitle: '@jobTitle',
            avatar: '@avatar',
            searchPhrase: '@searchPhrase',
            avatarSize: '@?',
            replaceEmailWithCompanyName: '@?replaceEmailWithCompanyName',
            disableGotoContact: '@?',
            systemUserType: '@?',
            userId: '@?'
        },
        templateUrl : 'angular/app/modules/core/features/search/contact/search_contact_directive_template.html',
        controller : SearchContactDirectiveController,
        controllerAs : 'searchContactVm',
        bindToController : true

    };
};
